import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var PageLastIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 14 14" }),
        React.createElement("path", { d: "M0.827706 11.2142L5.03104 7L0.816875 2.78583C0.394375 2.36333 0.394375 1.68083 0.816875 1.25833C1.23937 0.835833 1.92187 0.835833 2.34437 1.25833L7.31687 6.23083C7.73937 6.65333 7.73937 7.33583 7.31687 7.75833L2.34437 12.7308C1.92187 13.1533 1.23937 13.1533 0.816875 12.7308C0.405208 12.3192 0.405206 11.6258 0.827706 11.2142ZM12.4194 0.5C11.8235 0.5 11.336 0.9875 11.336 1.58333V12.4167C11.336 13.0125 11.8235 13.5 12.4194 13.5C13.0152 13.5 13.5027 13.0125 13.5027 12.4167V1.58333C13.5027 0.9875 13.0152 0.5 12.4194 0.5Z" })));
};

export { PageLastIcon };
//# sourceMappingURL=PageLastIcon.esm.js.map
